"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_social-inputs.scss"), require("../styles/_highlighted-icons.scss");
var ICON_MAP = {
  website: "web",
  facebook: "facebook",
  twitter: "twitter",
  linkedIn: "linkedin",
  other: "options"
};

function SocialInputs(_ref) {
  var onUpdateField = _ref.onUpdateField,
      socialProfiles = _ref.socialProfiles,
      allowedSocialTypes = _ref.allowedSocialTypes,
      isValidURL = _ref.isValidURL,
      disabled = _ref.disabled;
  return _react["default"].createElement("div", {
    className: "social-inputs"
  }, Object.keys(socialProfiles).map(function (socialKey) {
    return !allowedSocialTypes || allowedSocialTypes.includes(socialKey) ? _react["default"].createElement(_uiKit.Input, {
      key: socialKey,
      defaultValue: socialProfiles[socialKey].value,
      className: (0, _classnames["default"])("social-inputs__input"),
      value: socialProfiles[socialKey].value,
      prefix: _react["default"].createElement(_uiKit.Icon, {
        name: ICON_MAP[socialKey],
        className: (0, _classnames["default"])("social-icon", "social-icon-".concat(socialKey.toLowerCase()), {
          "social-icon--highlighted": !!socialProfiles[socialKey].value
        }),
        color: "white",
        size: 17
      }),
      placeholder: "Enter ".concat(socialKey, " URL"),
      onChange: onUpdateField(socialKey),
      validate: isValidURL,
      errorMessage: "Invalid URL",
      disabled: disabled
    }) : null;
  }));
}

var _default = (0, _react.memo)(SocialInputs);

exports["default"] = _default;